import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import take from 'lodash/take';
import { Tooltip } from '@vectord/components';

import SbatGroupResourceType from 'propTypes/sbatGroupResourceType';

const MAX_BATCHES_WHEN_TRIMMED = 3;

function SbatGroupSuperBatches({ sbatGroup, trimIfMany = false }) {
  const shouldTrim =
    trimIfMany &&
    sbatGroup.super_batch_academy_topics.length > MAX_BATCHES_WHEN_TRIMMED;

  const allBatchNames = useMemo(() => {
    return sbatGroup.super_batch_academy_topics
      .map((sbat) => sbat.super_batch.name)
      .join(', ');
  }, [sbatGroup.super_batch_academy_topics]);

  const visibleBatchNames = useMemo(() => {
    if (shouldTrim) {
      const trimmedBatches = take(
        sbatGroup.super_batch_academy_topics,
        MAX_BATCHES_WHEN_TRIMMED
      );

      const batchNames = trimmedBatches
        .map((sbat) => sbat.super_batch.name)
        .join(', ');
      const remainingBatchesCount =
        sbatGroup.super_batch_academy_topics.length - MAX_BATCHES_WHEN_TRIMMED;

      return `${batchNames} and ${remainingBatchesCount} more`;
    } else {
      return allBatchNames;
    }
  }, [shouldTrim, sbatGroup.super_batch_academy_topics, allBatchNames]);

  return (
    <Tooltip
      title={allBatchNames}
      isDisabled={!shouldTrim}
    >
      {visibleBatchNames}
    </Tooltip>
  );
}

SbatGroupSuperBatches.propTypes = {
  sbatGroup: SbatGroupResourceType,
  trimIfMany: PropTypes.bool,
};

export default SbatGroupSuperBatches;
